module.exports = __webpack_public_path__ + "static/cycle-trading-co-3798a22de69f0ff24ae43bacaa93ad73.png";